import { render, staticRenderFns } from "./MultiSelectDialog.vue?vue&type=template&id=524d351e&scoped=true"
import script from "./MultiSelectDialog.vue?vue&type=script&lang=js"
export * from "./MultiSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectDialog.vue?vue&type=style&index=0&id=524d351e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d351e",
  null
  
)

export default component.exports